// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.coding-tab a[data-v-025407df] {\n  background: black !important;\n  color: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
